import React from "react";
import "./index.css";

function DecisionMakingDecisionComponent({ medicalDecisionMaking = "" }) {
  return (
    <div className="card custom-card">
      <h5 className="card-header ">
        <strong>MEDICAL DECISION MAKING / DISCUSSION</strong>
      </h5>
      <div className="card-body">
        <div className="custom-form-group-container pe-text">
          {medicalDecisionMaking || ""}
        </div>
      </div>
    </div>
  );
}

export default DecisionMakingDecisionComponent;
